var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"down-top-padding",attrs:{"fluid":""}},[_c('base-breadcrumb',{attrs:{"title":_vm.page.title}}),_c('base-card',{attrs:{"heading":"Importar Avaliação"}},[_c('form-exam-import')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }